import Action from './action';

const initialState = {
    registrationAddress: null,
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: {id: number, name: string}}) => {
    switch (action.type) {
        case Action.UPDATE_REGISTRATION_ADDRESS: {
            return {
                ...state,
                registrationAddress: action.playload
            }
        }
        case Action.UPDATE_REGISTRATION_ADDRESS_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('registration_address_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
